export function addUniquenotEmptyElements(entities) {
    return entities.filter(function (entity, index, self) {
        return self.findIndex(function (e) { return e === entity; }) === index;
    }).filter(function (e) { return e !== undefined && e !== null; });
}
//# sourceMappingURL=addUniquenotEmptyElements.js.map